/*

Fluid videos on responsive websites; see this CSS-Tricks.com page:
http://css-tricks.com/NetMag/FluidWidthVideo/Article-FluidWidthVideo.php

*/

( function( $ ) { // opens jQuery ready function
	// Find all YouTube videos
	var $allVideos = $( "iframe[src^='http://www.youtube.com'], iframe[src^='http://player.vimeo.com'], object, embed" ),

		// The element that has fluid width
		$fluidEl = $( '.post__content :not(.video-container)' );

	// Figure out and save aspect ratio for each video
	$allVideos.each( function() {

	$( this )
		// jQuery .data does not work on object/embed elements
		//.data('aspectRatio', this.height/this.width)
		.attr( 'data-aspectRatio', this.height / this.width )

		// and remove the hard coded width/height
		.removeAttr( 'height' )
		.removeAttr( 'width' );

	} );

	// When the window is resized
	$( window ).resize( function() { // opens window resize function

		var newWidth = $fluidEl.width();

		// Resize all videos according the their own aspect ratio
		$allVideos.each( function() {

			var $el = $( this );
			$el
				.width( newWidth )
				.height( newWidth * $el.attr( 'data-aspectRatio' ) );

		} );

	} ).resize(); // closes window resize function


// closes jQuery ready function
} )( jQuery );
